<template>
  <v-row class="billing-info" justify="center">
    <v-col cols="12" sm="12" md="10" lg="10">
      <v-row justify="center">
        <v-col cols="12" sm="12" md="6" lg="4">
          <v-menu
            v-model="fromDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-select dense single-line outlined :value="picker" :label="billingSelectLabel" v-on="on"></v-select>
            </template>
            <v-date-picker
              no-title
              :locale="pickerLocale"
              v-model="picker"
              type="month"
              color="#9B8616"
              @change="setYearMonth()"
              :max="maxSelectableYearMonth"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="12" md="6" lg="5">
          <v-select
            v-model="invoiceId"
            class="select-invoice"
            :label="$t('message.invoice_select_title')"
            single-line
            outlined
            :items="invoiceList"
            item-value="id"
            item-text="title"
            @change="selectInvoice()"
          ></v-select>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="10" sm="6" md="6" lg="3">
          <v-btn @click="downloadPdf()" class="pdf-download" depressed :disabled="!canDownload">
            <v-icon>mdi-file-outline</v-icon>{{ $t('message.btn_pdf') }}
          </v-btn>
        </v-col>
      </v-row>

      <v-list>
        <v-list-item-group active-class="black--text" class="px-0">
          <v-list-item-content class="total-bills">
            <div class="list-content-wrapper">
              <v-row>
                <v-col cols="6">
                  <v-list-item-title class="total-bills-label text-wrap">{{
                    $t('message.total_amount')
                  }}</v-list-item-title>
                </v-col>
                <v-col cols="6">
                  <v-list-item-title class="total-bills-value text-wrap">{{
                    subListMoney(invoice.total)
                  }}</v-list-item-title>
                </v-col>
              </v-row>
            </div>
          </v-list-item-content>

          <v-divider></v-divider>

          <div v-for="(item, key) in invoice.invoices" :key="key">
            <v-list-group sub-group no-action class="px-0">
              <template v-slot:activator>
                <v-list-item-content class="total-sales">
                  <div class="list-content-wrapper">
                    <v-row>
                      <v-col cols="6">
                        <v-list-item-title
                          class="item-category text-wrap"
                          v-text="navigatorLanguage === 'ja' ? item.text : item.en_text"
                        ></v-list-item-title>
                      </v-col>
                      <v-col cols="6">
                        <v-list-item-title :class="subTotalMoneyColor(item.label)">{{
                          subListMoney(item.amount, item.label)
                        }}</v-list-item-title>
                      </v-col>
                    </v-row>
                  </div>
                </v-list-item-content>
              </template>
              <v-list-item v-if="!Object.keys(item.breakdown).length"> </v-list-item>
              <v-list-item v-for="(item, key) in item.breakdown" :key="key">
                <v-list-item-title class="item-category text-wrap">{{
                  navigatorLanguage === 'ja' ? item.text : item.en_text
                }}</v-list-item-title>
                <v-list-item-title :class="subListMoneyColor(item.label)">{{
                  subListMoney(item.amount)
                }}</v-list-item-title>
              </v-list-item>
            </v-list-group>
            <v-divider></v-divider>
          </div>
        </v-list-item-group>
      </v-list>
    </v-col>
  </v-row>
</template>

<script>
import pdfMake from 'pdfmake/build/pdfmake'
import '../../../public/pdfmake/vfs_fonts.js'
export default {
  props: {
    contractId: {
      type: Number
    }
  },
  watch: {
    contractId() {
      this.setKitchen()
    }
  },
  data() {
    return {
      invoiceId: null,
      today: '',
      picker: '',
      fromDateMenu: false,
      canDownload: false
    }
  },
  computed: {
    licenseeName() {
      return this.$store.getters['licensees/licenseeName']
    },
    contract() {
      return this.$store.getters['contracts/contract']
    },
    restaurants() {
      return this.$store.getters['restaurants/restaurants']
    },
    invoiceList() {
      return this.$store.getters['invoices/invoiceList']
    },
    invoice() {
      return this.$store.getters['invoices/invoice']
    },
    invoiceParams() {
      return this.$store.getters['invoices/params']
    },
    billingSelectLabel() {
      const year = this.$moment(this.picker).format('Y')
      const month = this.$moment(this.picker).format('M')
      if (navigator.language !== 'ja') {
        const monthEn = this.$moment(this.picker).format('MMMM')
        return 'Payment in ' + monthEn + ' ' + year
      }
      return year + '年' + month + '月お支払い'
    },
    pickerLocale() {
      if (navigator.language !== 'ja') {
        return 'en'
      }
      return 'ja'
    },
    navigatorLanguage() {
      if (navigator.language !== 'ja') {
        return 'en'
      }
      return 'ja'
    },
    subListMoney() {
      return function (amount, label) {
        let formattedAmount = amount ? amount.toLocaleString() : '0'
        if (label) {
          if (label.match('tax')) {
            return '(¥' + formattedAmount + ')'
          }
        }
        if (formattedAmount.match(/-/g)) {
          return '- ¥' + formattedAmount.replace(/-/g, '')
        } else {
          return '¥' + formattedAmount
        }
      }
    },
    subTotalMoneyColor() {
      return function (amount) {
        if (amount < 0) {
          return 'money-minus text-wrap'
        } else {
          return 'money-plus text-wrap'
        }
      }
    },
    subListMoneyColor() {
      return function (amount) {
        if (amount < 0) {
          return 'sub-list-money-minus text-wrap'
        } else {
          return 'sub-list-money-plus text-wrap'
        }
      }
    },
    formatJpDate() {
      return function (date) {
        return new Intl.DateTimeFormat('ja-JP-u-ca-japanese', {
          era: 'long',
          year: 'numeric',
          month: 'narrow',
          day: 'numeric'
        }).format(this.$moment(date))
      }
    },
    maxSelectableYearMonth() {
      if (this.$moment(this.today).startOf('months').add(8, 'd').isBefore(this.today)) {
        return this.$moment(this.today).format('YYYY-MM')
      } else {
        return this.$moment(this.today).subtract(1, 'M').format('YYYY-MM')
      }
    },
    paymentComment() {
      if (this.invoice.is_auto) {
        return 'キッチンサービス利用に基づく費用及び償還可能サービス費として、下記の通り振替させて頂きます。'
      } else {
        return 'キッチンサービス利用に基づく費用及び償還可能サービス費として、下記の通りご請求致します。'
      }
    },
    fileName() {
      return `KitchenBASE_invoice_${this.invoice.invoice_id}_${this.licenseeName}様`
    }
  },
  created() {
    this.today = this.$moment().startOf('day')
    if (this.$moment().startOf('months').add(8, 'd').isBefore(this.today)) {
      this.picker = this.$moment().format('YYYY-MM')
    } else {
      this.picker = this.$moment().subtract(1, 'M').format('YYYY-MM')
    }
    this.setYearMonth()
  },
  methods: {
    selectInvoice() {
      this.$store.dispatch('invoices/getInvoice', this.invoiceId)
    },
    async setKitchen() {
      this.canDownload = false
      const params = this.invoiceParams
      params.kitchen_id = this.contract.kitchen_id
      this.$store.dispatch('invoices/setParams', params)
      await this.$store.dispatch('invoices/getInvoiceList', this.invoiceParams)
      if (this.invoiceList.length > 0) {
        this.canDownload = true
        this.invoiceId = this.invoiceList[0].id
        await this.$store.dispatch('invoices/getInvoice', this.invoiceList[0].id)
      }
    },
    async setYearMonth() {
      this.fromDateMenu = false
      this.canDownload = false
      const yearMonthExceptDash = this.picker.replace(/-/g, '')
      this.$store.dispatch('invoices/setParams', {
        payment_year_month: yearMonthExceptDash,
        kitchen_id: this.contract.kitchen_id
      })
      await this.$store.dispatch('invoices/getInvoiceList', {
        payment_year_month: yearMonthExceptDash,
        kitchen_id: this.contract.kitchen_id
      })
      if (this.invoiceList.length > 0) {
        this.canDownload = true
        this.invoiceId = this.invoiceList[0].id
        await this.$store.dispatch('invoices/getInvoice', this.invoiceList[0].id)
      }
    },
    downloadPdf() {
      pdfMake.fonts = {
        GenShin: {
          normal: 'GenShinGothic-Normal-Sub.ttf',
          bold: 'GenShinGothic-Normal-Sub.ttf',
          italics: 'GenShinGothic-Normal-Sub.ttf',
          bolditalics: 'GenShinGothic-Normal-Sub.ttf'
        }
      }
      const defaultStyle = 'GenShin'

      let tableBody = [
        [
          { text: '項目', style: 'tableHeader' },
          { text: '金額', style: 'tableHeader' },
          { text: '摘要', style: 'tableHeader' }
        ]
      ]

      let subtotalCount = 0
      for (var i = 0; i < this.invoice.invoices.length; i++) {
        if (this.invoice.invoices[i].label.match('OTH')) {
          continue
        }
        for (var j in this.invoice.invoices[i].breakdown) {
          subtotalCount++
          tableBody.push([
            {
              text: this.invoice.invoices[i].breakdown[j].text + ' / ' + this.invoice.invoices[i].breakdown[j].en_text,
              style: 'label'
            },
            {
              text: this.subListMoney(this.invoice.invoices[i].breakdown[j].amount),
              style: 'amount',
              align: 'right'
            },
            {
              text: this.invoice.invoices[i].breakdown[j].note,
              style: 'note'
            }
          ])
        }
      }

      tableBody.push([
        { text: '小計 / Subtotal', style: 'label' },
        { text: this.subListMoney(this.invoice.subtotal), style: 'amount' },
        { text: '消費税込み', style: 'note' }
      ])

      tableBody.push([
        { text: '内消費税額 / Japan Consumption Tax', style: 'label' },
        { text: this.subListMoney(this.invoice.tax_included), style: 'amount' },
        { text: '', style: 'note' }
      ])

      for (var k = 0; k < this.invoice.invoices.length; k++) {
        if (!this.invoice.invoices[k].label.match('OTH')) {
          continue
        }
        for (var l in this.invoice.invoices[k].breakdown) {
          tableBody.push([
            {
              text: this.invoice.invoices[k].breakdown[l].text + ' / ' + this.invoice.invoices[k].breakdown[l].en_text,
              style: 'label'
            },
            {
              text: this.subListMoney(this.invoice.invoices[k].breakdown[l].amount),
              style: 'amount',
              align: 'right'
            },
            {
              text: this.invoice.invoices[k].breakdown[l].note,
              style: 'note'
            }
          ])
        }
      }

      tableBody.push([
        { text: '合計 / Total', style: 'label' },
        { text: this.subListMoney(this.invoice.total), style: 'amount' },
        { text: '', style: 'note' }
      ])

      let totalTable = [
        {
          table: {
            body: [
              [
                {
                  text: [
                    { text: 'ご請求金額 (税込)', fontSize: 12, bold: true },
                    { text: '              ', fontSize: 12 },
                    { text: this.subListMoney(this.invoice.total), fontSize: 14, bold: true }
                  ]
                }
              ]
            ]
          },
          layout: {
            paddingLeft: function () {
              return 20
            },
            paddingRight: function () {
              return 20
            },
            paddingTop: function () {
              return 5
            },
            paddingBottom: function () {
              return 5
            }
          }
        },
        {
          text: this.invoice.facility_name + '　Kitchen ' + this.invoice.kitchen_number,
          alignment: 'right',
          fontSize: 10,
          margin: [0, 10, 0, 0]
        },
        {
          text: 'キッチンサービス利用料として',
          alignment: 'right',
          fontSize: 10,
          margin: [0, 4, 0, 0]
        }
      ]

      let companyTable = [
        {
          text: this.invoice.company_name,
          fontSize: 12,
          margin: [40, 0, 0, 5]
        },
        {
          style: 'tableExample',
          table: {
            headerRows: 1,
            widths: [30, '*'],
            body: [
              [
                { text: '住所', fontSize: 10 },
                {
                  text: this.invoice.billing_info.billing_address,
                  fontSize: 10
                }
              ],
              [
                { text: '代表', fontSize: 10 },
                {
                  text: this.invoice.billing_info.billing_representative_name,
                  fontSize: 10
                }
              ],
              [
                { text: 'Email', fontSize: 10 },
                {
                  text: this.invoice.billing_info.billing_email,
                  fontSize: 10
                }
              ]
            ]
          },
          layout: 'noBorders',
          margin: [40, 0, 0, 0]
        },
        {
          image: 'data:image/png;base64,' + this.invoice.stamp,
          absolutePosition: { x: 435, y: 200 },
          fit: [50, 50]
        }
      ]

      let paymentTable = []
      if (this.invoice.is_auto_withdrawal) {
        paymentTable = [
          {
            text: 'ご指定の口座より振替させていただきます。',
            fontSize: 10,
            margin: [0, 10, 0, 5]
          },
          {
            style: 'tableExample',
            table: {
              headerRows: 1,
              widths: [80, '*'],
              body: [
                [
                  { text: '引き落とし予定日', fontSize: 10 },
                  {
                    text: this.formatJpDate(this.invoice.due_date),
                    fontSize: 10,
                    bold: true
                  }
                ]
              ]
            },
            layout: 'noBorders',
            margin: [0, 5, 0, 5]
          },
          {
            text: '引き落とし予定日が土日祝日の場合は翌営業日でのお振替となります。',
            fontSize: 10,
            margin: [0, 5, 0, 5]
          }
        ]
      } else if (this.invoice.is_deposit) {
        paymentTable = [
          {
            text: '受領済デポジットとのご精算となります。',
            fontSize: 10,
            margin: [0, 10, 0, 5]
          }
        ]
      } else {
        paymentTable = [
          {
            text: 'お振込先',
            fontSize: 12,
            margin: [0, 10, 0, 5]
          },
          {
            style: 'tableExample',
            table: {
              headerRows: 1,
              widths: [80, '*'],
              body: [
                [
                  { text: '銀行名称', fontSize: 10 },
                  {
                    text: this.invoice.billing_info.bank_name + '  ' + this.invoice.billing_info.bank_branch_name,
                    fontSize: 10
                  }
                ],
                [
                  { text: '口座番号', fontSize: 10 },
                  {
                    text:
                      this.invoice.billing_info.bank_account_type +
                      '  ' +
                      this.invoice.billing_info.bank_account_number,
                    fontSize: 10
                  }
                ],
                [
                  { text: '口座名義', fontSize: 10 },
                  {
                    text: this.invoice.billing_info.bank_account_name,
                    fontSize: 10
                  }
                ],
                [
                  { text: 'お支払い期限', fontSize: 10 },
                  {
                    text: this.formatJpDate(this.invoice.due_date) + '迄',
                    fontSize: 10,
                    bold: true
                  }
                ]
              ]
            },
            layout: 'noBorders',
            margin: [0, 5, 0, 5]
          },
          {
            text: '振込手数料は貴殿にてご負担をお願い致します。',
            fontSize: 10,
            margin: [0, 5, 0, 5]
          }
        ]
      }

      // const atena = this.licensee.is_solo ? '様' : '御中'
      const atena = '様'

      const docDefinition = {
        pageSize: 'A4',
        content: [
          {
            text: '御請求書',
            style: 'header',
            alignment: 'center',
            margin: [0, 10]
          },
          {
            alignment: 'justify',
            columns: [
              [
                {
                  text: this.licenseeName + ' ' + atena,
                  style: 'licensee_name'
                }
              ],
              [
                {
                  text: '請求番号 ' + this.invoice.invoice_id,
                  alignment: 'right',
                  style: { fontSize: 10 }
                },
                {
                  text: this.formatJpDate(this.invoice.invoice_date),
                  alignment: 'right',
                  style: { fontSize: 10 }
                }
              ]
            ],
            margin: [0, 10, 0, 0]
          },
          {
            text: '平素より Kitchen BASE をご利用ありがとうございます。',
            style: { fontSize: 10 },
            margin: [0, 10, 0, 0]
          },
          {
            text: this.paymentComment,
            style: { fontSize: 10 },
            margin: [0, 0, 0, 0]
          },
          {
            text: 'よろしくお願い申し上げます。',
            style: { fontSize: 10 },
            margin: [0, 0, 0, 10]
          },
          {
            alignment: 'justify',
            columns: [totalTable, companyTable],
            margin: [0, 20, 0, 10]
          },
          {
            style: 'tableExample',
            table: {
              headerRows: 1,
              widths: [240, 60, '*'],
              body: tableBody
            },
            layout: {
              hLineWidth: function (i, node) {
                return i <= 1 ||
                  i === subtotalCount + 1 ||
                  i === subtotalCount + 3 ||
                  i === node.table.body.length - 1 ||
                  i === node.table.body.length
                  ? 2
                  : 1
              },
              vLineWidth: function (i, node) {
                return i === 0 || i === node.table.widths.length ? 2 : 1
              },
              hLineColor: function (i, node) {
                return i <= 1 ||
                  i === subtotalCount + 1 ||
                  i === subtotalCount + 3 ||
                  i === node.table.body.length - 1 ||
                  i === node.table.body.length
                  ? 'black'
                  : 'gray'
              },
              vLineColor: function (i, node) {
                return i === 0 || i === node.table.widths.length ? 'black' : 'gray'
              }
            },
            margin: [0, 5, 0, 10]
          }
        ],
        defaultStyle: {
          font: defaultStyle
        },
        styles: {
          header: {
            fontSize: 16
          },
          licensee_name: {
            fontSize: 16,
            decoration: 'underline'
          },
          tableHeader: {
            fontSize: 8
          },
          label: {
            fontSize: 9,
            margin: [1.5, 1.5],
            alignment: 'left'
          },
          amount: {
            fontSize: 10,
            margin: [1, 1],
            alignment: 'right'
          },
          note: {
            fontSize: 8,
            margin: [2, 2],
            alignment: 'left'
          }
        }
      }
      docDefinition.content = docDefinition.content.concat(paymentTable)

      pdfMake.createPdf(docDefinition).download(this.fileName)
    }
  }
}
</script>

<style lang="scss" scoped>
.billing-info {
  width: 100%;
  clear: both;
}
.row {
  margin: 0 !important;
}
.billing-info ::v-deep .col {
  padding: 0;
}
.billing-info ::v-deep .v-select {
  width: 100%;
  height: 40px;
  display: inline-block;
}
.billing-info ::v-deep .pdf-download {
  width: 100%;
  height: 40px;
  background: #66bb6a !important;
  border-radius: 8px;
  color: #fff;
  text-transform: none;
}
.billing-info ::v-deep .v-icon {
  margin-right: 15px;
}
.billing-info ::v-deep .total-bills {
  margin: 12px 5px;
}
.billing-info ::v-deep .total-bills-label {
  font-weight: bolder;
  font-size: 18px;
}
.billing-info ::v-deep .total-bills-value {
  font-family: Hiragino Kaku Gothic Pro;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  color: #000;
  float: right;
}
.billing-info ::v-deep .v-list-group__header {
  margin: 30px 0 30px 0;
}
.billing-info ::v-deep .v-list-item__title {
  display: inline-block;
  line-height: 22px;
}
.billing-info ::v-deep .v-list-item {
  margin-bottom: 20px;
}
.billing-info ::v-deep .list-content-wrapper {
  clear: both;
}
.billing-info ::v-deep .money {
  font-family: Hiragino Kaku Gothic Pro;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;
  color: #c42929;
  float: right;
}
.total-sales ::v-deep .money-plus {
  font-family: Hiragino Kaku Gothic Pro;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;
  color: #000000;
  float: right;
}
.total-sales ::v-deep .money-minus {
  font-family: Hiragino Kaku Gothic Pro;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;
  color: #c42929;
  float: right;
}
.billing-info ::v-deep .sub-list-money-minus {
  font-family: Hiragino Kaku Gothic Pro;
  font-style: normal;
  font-size: 14px;
  line-height: 22px;
  color: #c42929;
  text-align: right;
  margin-right: 16px;
}
.billing-info ::v-deep .sub-list-money-plus {
  font-family: Hiragino Kaku Gothic Pro;
  font-style: normal;
  font-size: 14px;
  line-height: 22px;
  text-align: right;
  margin-right: 16px;
}

@media screen and (max-width: 767px) {
  .billing-info ::v-deep .money,
  .total-sales ::v-deep .money-plus,
  .total-sales ::v-deep .money-minus,
  .billing-info ::v-deep .sub-list-money-minus,
  .billing-info ::v-deep .sub-list-money-plus {
    font-size: 12px;
  }

  .item-category {
    font-size: 13.5px;
  }
}

.select-invoice ::v-deep .v-input__slot {
  width: 100%;
  min-height: 40px !important;
  border-radius: 6px;
  display: inline-block;
  background-color: #ffffff;
}
.select-invoice ::v-deep label {
  top: 10px;
}
.select-invoice ::v-deep .v-select__selection {
  margin-top: 10px;
}
.select-invoice ::v-deep .v-input__append-inner {
  margin-top: 8px;
}
</style>
